import PageLoader from './PageLoader.component';

export default PageLoader;